import styled from 'styled-components';
import ds from 'designsystem';

import PanelGroup from 'blocks/PanelGroup/index';

import Paragraph from './Paragraph';
import Image from './Image';
import Video from './Video';

/* eslint react/destructuring-assignment: "off" */

const StyledPanelBody = styled(PanelGroup.Body)`
    border-bottom: ${props => (props['data-isspread'] ? `1px solid ${ds.brand('background')}` : 'none')};
`;

StyledPanelBody.Paragraph = Paragraph;
StyledPanelBody.Image = Image;
StyledPanelBody.Video = Video;

export default StyledPanelBody;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/index.jsx